import { r as register } from "main/preact-custom-element.esm";
import { t, d, y, u } from "main/jsxRuntime.module";
var _jsxFileName = "/home/runner/work/THEM_ForThem/THEM_ForThem/src/components/ui/SubscriptionDropdown.tsx";
const updateCartItemDirect = async (lineItemKey, sellingPlanId) => {
  const payload = {
    id: lineItemKey,
    selling_plan: sellingPlanId
  };
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();
  if (data.errors) {
    throw new Error(JSON.stringify(data.errors));
  }
  return data;
};
const refreshCartSections = async () => {
  var _a, _b;
  if ((_b = (_a = window.Shopify) == null ? void 0 : _a.cart) == null ? void 0 : _b.refreshCart) {
    await window.Shopify.cart.refreshCart();
  } else {
    document.dispatchEvent(new CustomEvent("theme:cart:refresh", {
      bubbles: true
    }));
  }
};
const triggerSubscriptionGifts = async (cartData, sellingPlanId, sellingPlanName, lineItemKey) => {
  var _a, _b, _c;
  try {
    const updatedItem = (_a = cartData.items) == null ? void 0 : _a.find((item) => {
      var _a2, _b2, _c2;
      if (((_c2 = (_b2 = (_a2 = item.selling_plan_allocation) == null ? void 0 : _a2.selling_plan) == null ? void 0 : _b2.id) == null ? void 0 : _c2.toString()) === sellingPlanId.toString()) {
        return true;
      }
      if (lineItemKey && item.key === lineItemKey) {
        return true;
      }
      return false;
    });
    if (!updatedItem) {
      console.warn("SubscriptionDropdown: Could not find updated item in cart for subscription gifts");
      return;
    }
    const isMembershipProduct = checkIfMembershipProduct(updatedItem);
    if (!isMembershipProduct) {
      return;
    }
    let productHandle = updatedItem.product_handle;
    if (!productHandle) {
      productHandle = await getProductHandle(updatedItem.product_id);
    }
    if (!productHandle) {
      console.warn("SubscriptionDropdown: Could not get product handle for subscription gifts");
      return;
    }
    let planName = sellingPlanName;
    if (!planName && ((_c = (_b = updatedItem.selling_plan_allocation) == null ? void 0 : _b.selling_plan) == null ? void 0 : _c.name)) {
      planName = updatedItem.selling_plan_allocation.selling_plan.name;
    }
    if (!planName) {
      console.warn("SubscriptionDropdown: Could not get selling plan name for subscription gifts");
      return;
    }
    if (typeof window !== "undefined" && window.dispatchSubscriptionAdded) {
      window.dispatchSubscriptionAdded(productHandle, updatedItem.product_id, planName);
    } else {
      document.dispatchEvent(new CustomEvent("theme:subscription:added", {
        bubbles: true,
        detail: {
          handle: productHandle,
          product_id: updatedItem.product_id,
          selling_plan_name: planName
        }
      }));
    }
  } catch (error) {
    console.error("SubscriptionDropdown: Error triggering subscription gifts:", error);
  }
};
const checkIfMembershipProduct = (item) => {
  var _a, _b, _c;
  const membershipVariantIds = ["44792925257894", "46214081347750"];
  if (membershipVariantIds.includes((_a = item.variant_id) == null ? void 0 : _a.toString())) {
    return true;
  }
  if ((_c = (_b = item.selling_plan_allocation) == null ? void 0 : _b.selling_plan) == null ? void 0 : _c.id) {
    const membershipSellingPlanIds = ["1580236966", "1580236967"];
    const sellingPlanId = item.selling_plan_allocation.selling_plan.id.toString();
    if (membershipSellingPlanIds.includes(sellingPlanId)) {
      return true;
    }
  }
  if (item.product_handle === "af-membership") {
    return true;
  }
  return false;
};
const getProductHandle = async (productId) => {
  var _a, _b;
  try {
    const response = await fetch("/cart.js");
    if (response.ok) {
      const cart = await response.json();
      const item = cart.items.find((item2) => item2.product_id === productId);
      if (item == null ? void 0 : item.product_handle) {
        return item.product_handle;
      }
    }
    const query = `
      query GetProduct($id: ID!) {
        node(id: $id) {
          ... on Product {
            id
            handle
          }
        }
      }
    `;
    const storefrontResponse = await fetch("https://for-them-store.myshopify.com/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "8325b00bc1524b6c8863c616e9226760"
      },
      body: JSON.stringify({
        query,
        variables: {
          id: `gid://shopify/Product/${productId}`
        }
      })
    });
    if (storefrontResponse.ok) {
      const data = await storefrontResponse.json();
      return ((_b = (_a = data.data) == null ? void 0 : _a.node) == null ? void 0 : _b.handle) || null;
    }
    return null;
  } catch (error) {
    return null;
  }
};
function SubscriptionDropdown(props) {
  const [isOpen, setIsOpen] = t(d(false), "isOpen");
  const [isLoading, setIsLoading] = t(d(false), "isLoading");
  const lineItemKey = props["line-item-key"];
  const currentPlan = typeof props["current-plan"] === "string" ? JSON.parse(props["current-plan"]) : props["current-plan"];
  const sellingPlanGroups = typeof props["selling-plan-groups"] === "string" ? JSON.parse(props["selling-plan-groups"]) : props["selling-plan-groups"];
  const {
    onPlanChange
  } = props;
  const allPlans = sellingPlanGroups.reduce((acc, group) => {
    return [...acc, ...group.selling_plans];
  }, []);
  const handlePlanChange = async (planId) => {
    if (planId === currentPlan.id || isLoading) {
      return;
    }
    setIsLoading(true);
    setIsOpen(false);
    const selectedPlan = allPlans.find((plan) => plan.id === planId);
    try {
      const cartUpdateResult = await updateCartItemDirect(lineItemKey, planId);
      window.dispatchEvent(new CustomEvent("cart:updated", {
        detail: {
          payload: {
            id: lineItemKey,
            selling_plan: planId
          },
          cart: cartUpdateResult
        }
      }));
      const freshCartResponse = await fetch("/cart.js");
      const freshCartData = await freshCartResponse.json();
      await triggerSubscriptionGifts(freshCartData, planId, selectedPlan == null ? void 0 : selectedPlan.name, lineItemKey);
      await refreshCartSections();
      if (onPlanChange) {
        onPlanChange(planId);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      alert(`Failed to update subscription plan: ${errorMessage}

Please try again.`);
    } finally {
      setIsLoading(false);
    }
  };
  y(() => {
    const handleClickOutside = (event) => {
      if (isOpen && event.target instanceof Element) {
        if (event.target.closest("dialog, .drawer, [data-modal], .modal")) {
          return;
        }
        const dropdown = event.target.closest(".subscription-dropdown");
        if (!dropdown) {
          setIsOpen(false);
        }
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isOpen]);
  if (!allPlans.length) {
    return u("p", {
      className: "cart__item__selling-plan",
      children: u("span", {
        children: currentPlan.name
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 317,
        columnNumber: 9
      }, this)
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 316,
      columnNumber: 7
    }, this);
  }
  return u("div", {
    className: "subscription-dropdown cart__item__subscription-dropdown",
    children: [u("button", {
      type: "button",
      className: `subscription-dropdown__toggle ${isLoading ? "is-loading" : ""}`,
      onClick: () => setIsOpen(!isOpen),
      disabled: isLoading,
      "aria-expanded": isOpen,
      "aria-haspopup": "listbox",
      children: [u("span", {
        className: "subscription-dropdown__current",
        children: isLoading ? "Updating..." : currentPlan.name
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 332,
        columnNumber: 9
      }, this), u("svg", {
        className: `subscription-dropdown__arrow ${isOpen ? "is-open" : ""}`,
        width: "11",
        height: "6",
        viewBox: "0 0 11 6",
        fill: "none",
        "aria-hidden": "true",
        children: u("path", {
          d: "M1 1L5.5 5L10 1",
          stroke: "currentColor",
          strokeWidth: "1",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }, void 0, false, {
          fileName: _jsxFileName,
          lineNumber: 343,
          columnNumber: 11
        }, this)
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 335,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 324,
      columnNumber: 7
    }, this), isOpen && u("div", {
      className: "subscription-dropdown__menu",
      role: "listbox",
      children: allPlans.map((plan) => u("button", {
        type: "button",
        className: `subscription-dropdown__option ${plan.id === currentPlan.id ? "is-selected" : ""}`,
        onClick: () => handlePlanChange(plan.id),
        role: "option",
        "aria-selected": plan.id === currentPlan.id,
        children: plan.name
      }, plan.id, false, {
        fileName: _jsxFileName,
        lineNumber: 350,
        columnNumber: 13
      }, this))
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 348,
      columnNumber: 9
    }, this)]
  }, void 0, true, {
    fileName: _jsxFileName,
    lineNumber: 323,
    columnNumber: 5
  }, this);
}
if (typeof window !== "undefined") {
  window.Shopify = window.Shopify || {};
  window.Shopify.cart = window.Shopify.cart || {};
}
register(SubscriptionDropdown, "subscription-dropdown", ["line-item-key", "current-plan", "selling-plan-groups"], {
  shadow: false
});
